import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿El libro es físico o digital?',
  a: 'Es un libro 100% digital en formato PDF. Esto te permite acceder inmediatamente después de la compra desde tu celular, tablet o computadora, sin esperar envíos.'
}, {
  q: '¿Cocinarle a mi perro me va a llevar mucho tiempo?',
  a: "¡Para nada! En el libro te enseñamos el método de 'Meal Prep' o preparación de viandas. Dedicando solo un par de horas el fin de semana, podés dejar lista la comida de toda la semana o incluso del mes."
}, {
  q: '¿Es más caro que comprar alimento balanceado?',
  a: "A mediano y largo plazo es mucho más económico. No solo los ingredientes frescos suelen costar menos que un balanceado de 'alta gama', sino que ahorrarás muchísimo dinero en visitas al veterinario por alergias y problemas de salud."
}, {
  q: 'Mi perro tiene el estómago sensible, ¿le hará mal el cambio?',
  a: "Justamente por eso incluimos el Bono de la 'Guía de transición paso a paso'. Te enseñamos cómo hacer el cambio de forma gradual durante 14 días para que su sistema digestivo se adapte perfectamente sin diarreas ni malestares."
}, {
  q: '¿Qué pasa si no me gusta el contenido?',
  a: 'Tenés una garantía de satisfacción incondicional de 7 días. Si sentís que el material no es lo que esperabas, nos mandás un mail y te devolvemos el 100% de tu dinero sin hacer preguntas.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-12 md:py-16 px-4 bg-cream" data-id="element-68">
      <div className="max-w-3xl mx-auto" data-id="element-69">
        <div className="text-center mb-8 md:mb-10" data-id="element-70">
          <h2 className="font-display text-3xl md:text-4xl font-bold text-primary mb-4" data-id="element-71">
            Preguntas Frecuentes
          </h2>
        </div>

        <div className="space-y-3" data-id="element-72">
          {faqs.map((faq, i) => <div key={i} className="bg-white border border-cream-dark rounded-xl overflow-hidden shadow-sm" data-id="element-73">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full flex items-center justify-between p-5 text-left focus:outline-none" data-id="element-74">
                <span className="font-bold text-primary text-lg pr-4" data-id="element-75">
                  {faq.q}
                </span>
                <ChevronDown className={`text-accent transition-transform duration-300 flex-shrink-0 ${openIndex === i ? 'rotate-180' : ''}`} size={24} data-id="element-76" />
              </button>
              <AnimatePresence data-id="element-77">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-78">
                    <div className="p-5 pt-0 text-brown-light leading-relaxed border-t border-cream-dark/50 mt-2" data-id="element-79">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}